(function() {
  var __sections__ = {};
  (function() {
    for(var i = 0, s = document.getElementById('sections-script').getAttribute('data-sections').split(','); i < s.length; i++)
      __sections__[s[i]] = true;
    })();
    (function() {
  if (!__sections__["footer"]) return;
  try {
    
  customElements.whenDefined('details-disclosure').then(() => {
    class MobileDisclosure extends DetailsDisclosure {
      constructor() {
        super();

        const collapseEnabled = this.dataset.collapse === 'true';
        if (!collapseEnabled) return;

        this.reset();
        window.addEventListener('on:breakpoint-change', this.reset.bind(this));
      }

      reset() {
        const isLargeScreen = window.matchMedia(theme.mediaQueries.md).matches;
        this.disclosure.open = isLargeScreen;

        if (isLargeScreen) {
          this.toggle.setAttribute('tabindex', '-1');
          this.querySelectorAll('.disclosure, .disclosure__title, .disclosure__panel, .disclosure__content').forEach((el) => {
            [...el.classList].filter((cl) => cl.indexOf('disclosure') === 0).forEach((cl) => {
              el.classList.remove(cl);
              el.classList.add(`mobile-${cl}`);
            });
          });
        } else {
          this.toggle.removeAttribute('tabindex');
          this.querySelectorAll('.mobile-disclosure, .mobile-disclosure__title, .mobile-disclosure__panel, .mobile-disclosure__content').forEach((el) => {
            [...el.classList].filter((cl) => cl.indexOf('mobile-disclosure') === 0).forEach((cl) => {
              el.classList.remove(cl);
              el.classList.add(cl.substr(7));
            });
          });
        }
      }
    }

    customElements.define('mobile-disclosure', MobileDisclosure);
  });

  } catch(e) { console.error(e); }
})();

(function() {
  if (!__sections__["related-products"]) return;
  try {
    
var loadProductRecommendationsIntoSection = function() {
  // Look for an element with class 'related-products'
  var productRecommendationsSection = document.querySelector(".related-products");
  if (productRecommendationsSection === null) { return; }
  // Create request and submit it using Ajax
  var request = new XMLHttpRequest();
  request.open("GET", productRecommendationsSection.dataset.url);
  request.onload = function() {
    if (request.status >= 200 && request.status < 300) {
      var container = document.createElement("div");
      container.innerHTML = request.response;
      productRecommendationsSection.innerHTML = container.querySelector(".related-products").innerHTML;
    }
  };
  request.send();
};
// fetch when section reloads in editor
document.addEventListener("shopify:section:load", function(event) {
  if (document.querySelector('[data-section-id="' + event.detail.sectionId + '"].related-products')) {
    loadProductRecommendationsIntoSection();
  }
});
// Fetching the recommendations on page load
loadProductRecommendationsIntoSection();

  } catch(e) { console.error(e); }
})();

(function() {
  if (!__sections__["ssg"] && !Shopify.designMode) return;
  try {
    
  if (!customElements.get('ssg-ev-countdown')) {
    customElements.define(
      'ssg-ev-countdown',
      class extends HTMLElement {
        connectedCallback() {
          this.target = this.buildTarget(this.dataset.date, this.dataset.time, this.dataset.tz);
          this.out = this.querySelector('.ssg-ev__cd-time');
          this.label = this.querySelector('.ssg-ev__cd-label');
          if (isNaN(this.target)) return;
          this.hidden = false;
          this.tick();
          this.iv = setInterval(() => this.tick(), 1000);
        }
        disconnectedCallback() { clearInterval(this.iv); }
        buildTarget(dateStr, timeStr, tz) {
          const [y, mo, d] = (dateStr || '').split('-').map(Number);
          const [h, mi] = (timeStr || '00:00').split(':').map(Number);
          const want = Date.UTC(y, mo - 1, d, h, mi || 0);
          if (!tz || tz === 'UTC') return want;
          try {
            const fmt = new Intl.DateTimeFormat('en-US', { timeZone: tz, hour12: false, year: 'numeric', month: '2-digit', day: '2-digit', hour: '2-digit', minute: '2-digit' });
            const localAt = (ms) => {
              const m = {};
              fmt.formatToParts(new Date(ms)).forEach((p) => { m[p.type] = p.value; });
              return Date.UTC(+m.year, +m.month - 1, +m.day, +m.hour % 24, +m.minute);
            };
            let t = want + (want - localAt(want));
            return t + (want - localAt(t));
          } catch (e) { return want; }
        }
        tick() {
          const diff = Math.floor((this.target - Date.now()) / 1000);
          if (diff <= 0) {
            clearInterval(this.iv);
            this.label.textContent = this.dataset.live || '';
            this.out.textContent = '';
            return;
          }
          const d = Math.floor(diff / 86400), h = Math.floor((diff % 86400) / 3600), m = Math.floor((diff % 3600) / 60), s = diff % 60;
          const pad = (n) => String(n).padStart(2, '0');
          this.out.textContent = d + 'd ' + pad(h) + 'h ' + pad(m) + 'm ' + pad(s) + 's';
        }
      }
    );
  }

  } catch(e) { console.error(e); }
})();
})();
